import { ConversationType } from '../types/serialized-types';
import { Segment } from './segment';
import { find } from 'lodash';

class Conversation {
    segments: Segment[];

    static fromJSON(obj: ConversationType): Conversation {
        let c = new Conversation();

        obj.segments.forEach(segment => {
            c.segments.push(Segment.fromJSON(segment));
        });

        return c;
    }

    constructor(segments?: Segment[]) {
        this.segments = segments || [];
    }

    getSegment(id: string): Segment | null {
        return find(this.segments, s => s.id === id) || null;
    }

    allSegmentIds(): string[] {
        return this.segments.map(s => s.id);
    }
}

export {
    Conversation
}
